import type {
  LearningLesson,
  LearningLessonPage,
  LearningLessonQuestionPage,
  LessonPage,
  QuestionOption,
} from './learningTypes';

const PAGE_BLOCK_REGEX = /<page>([\s\S]*?)<\/page>([\s\S]*?)<button>([\s\S]*?)<\/button>/g;
const OPTION_REGEX = /<option>([\s\S]*?)<\/option>/g;
const TITLE_REGEX = /<title>([\s\S]*?)<\/title>/;

export const parseLessonTextFormat = (
  text: string,
  sectionLessonsCount: number
): { lessonData: Partial<LearningLesson>; pages: LessonPage[] } => {
  const titleMatch = TITLE_REGEX.exec(text);
  if (!titleMatch) {
    throw new Error('No <title> tag found in the pasted text');
  }

  const rawTitle = titleMatch[1].trim();
  const title = rawTitle.startsWith('#') ? rawTitle.replace(/^#+\s*/, '') : rawTitle;

  const uid = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const pages: LessonPage[] = [];
  let order = 1;
  let match: RegExpExecArray | null;

  PAGE_BLOCK_REGEX.lastIndex = 0;

  while ((match = PAGE_BLOCK_REGEX.exec(text)) !== null) {
    const content = match[1].trim();
    const between = match[2];
    const buttonText = match[3].trim();

    const isQuestion = content.includes('```question');

    if (isQuestion) {
      const options: QuestionOption[] = [];
      let optMatch: RegExpExecArray | null;
      OPTION_REGEX.lastIndex = 0;

      while ((optMatch = OPTION_REGEX.exec(between)) !== null) {
        options.push({
          uid: crypto.randomUUID(),
          text: optMatch[1].trim(),
        });
      }

      const questionPage: LearningLessonQuestionPage = {
        uid: '',
        content,
        order,
        buttonText,
        type: 'question',
        shouldSaveAnswer: true,
        options,
        correctOptionIds: [],
        aiFriendlyQuestion: '',
        correctAnswerReaction: '',
        incorrectAnswerReaction: '',
      };

      pages.push(questionPage);
    } else {
      const regularPage: LearningLessonPage = {
        uid: '',
        content,
        order,
        buttonText,
        type: 'page',
      };

      pages.push(regularPage);
    }

    order++;
  }

  if (pages.length === 0) {
    throw new Error('No pages found. Make sure the format uses <page>...</page> and <button>...</button> tags.');
  }

  const lessonData: Partial<LearningLesson> = {
    uid,
    title,
    description: 'ADD DESCRIPTION HERE',
    isFree: false,
    timeMinutes: Math.max(2, Math.floor(text.length / 1000)),
    type: 'lesson',
    status: 'draft',
    order: sectionLessonsCount + 1,
  };

  return { lessonData, pages };
};
